<template>
    <div class="container">
        <content-header title="Утро Вечера Мудренее"/>
        <article-detail-component :data="detail"/>
<!--        <comment-form id="comment-form" slug="утро-вечера-мудренее" class="comment-wrapper"/>-->
    </div>
</template>

<script>
import ContentHeader from "../../components/layout/ContentHeader";
import CommentForm from "@/components/CommentForm";
import ArticleDetailComponent from "@/components/ArticleDetailComponent";

export default {
    components: {
        ContentHeader,
        CommentForm,
        ArticleDetailComponent
    },
    data() {
        return {
            detail: {
                created: '22 ФЕВ 17',
                title: 'Утро Вечера Мудренее',
                description: `

<p class="ListParagraph" style="text-align: justify;"><span style="font-family: Verdana; font-size: 16px;"><span style="line-height: 115%; color: #595959;">В суете повседневности, бытовой спешке, «гонках по кабинетам», в очередях и автомобильных пробках многие постепенно забывают <b>обратить внимание</b> на то, <b>какого цвета сегодня небо</b>, что некоторые дома на улице оказывается, <b>красивые</b>, что зеркало может иногда и <b>улыбаться</b>… Какие простые слова, и, казалось бы, <b>очевидные и доступные</b> для того, чтобы пользоваться ими и успевать <b>радоваться</b> каждому утру… Вряд ли этому нужно учиться, это же <b>достаточно просто</b>! Но почему тогда люди об этом забывают?</span></span></p>
<p class="ListParagraph" style="text-align: justify;"><span style="font-family: Verdana; font-size: 16px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <span style="line-height: 115%; color: #595959;">Озабоченные проблемами и заботами, нахмуренные и устремившие свои взоры куда-то вниз — будто бы в поисках чего-то потерянного на тротуаре, многие&nbsp; просто не замечают, как становятся заложниками коварных формул типа «надо успеть!». Спору нет,<br>
сосредоточенность&nbsp; важна в любом деле. Но вопрос — в каких пределах и до каких пор? Вспомнить что-то важное и углубиться в раздумья по серьёзному поводу бывает необходимо так же, как и необходимо машине выполнить свою работу, чтобы доставить груз или пассажиров по назначению. Но машину необходимо заправлять, за ней нужно ухаживать — чтобы она была в рабочем состоянии. Достичь цели — важно, но для её достижения не менее<br>
важна одна из задач: «обеспечить работу всего, что необходимо для этого», в том числе — рабочее состояние машины. Нахмурив себя думками и проблемами, не пора ли озадачиться вопросом «а как я <b>восстанавливаю силы и как я ухаживаю за собой</b> после напряжённых раздумий и<br>
выполнения важных дел?». Надо ли повторять истину о том, что «<b>человек сложнее и ценнее любой машины</b>», что «<b>нервные клетки не восстанавливаются», а уж тем более — свои собственные?!</b> И почему тем, кто с детства запомнил: «делу время, <b>потехе час</b>» приходится напоминать о важности второй части этого тезиса?</span></span></p>
<p class="ListParagraph" style="text-align: justify;"><span style="font-family: Verdana; font-size: 16px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <span style="line-height: 115%; color: #595959;">Чаще всего самая важная работа мозга состоит в напряжении по поводу актуальных, но не способных быть решёнными в ближайшее время задач. Постепенно это становится проблемой, следом за которой приходят симптомы… Да, да, те самые, которые «от нервов». И тогда «нахмуренность с озадаченностью» становятся постоянными спутниками, заслоняющими собой всё остальное. Волевые усилия и внимание направлены только на проблему и как бы не позволяют видеть ничего другого вокруг. И тогда — не до восстановления сил и не до радостей. Постепенно эти стереотипы становятся доминирующими и предназначенные изначально для благих, казалось бы, целей, начинают «обслуживать проблему», делая её всё более неразрешимой…<br>
Программа становится деструктивной…</span></span></p>
<p class="ListParagraph" style="text-align: justify;"><span style="font-family: Verdana; font-size: 16px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <span style="line-height: 115%; color: #595959;">Можно ли вырваться из такого порочного круга? И как? Вряд ли ответ может быть простым и однозначным.<br>
Но то, что можно — однозначно ДА!</span></span></p>
<p class="ListParagraph" style="text-align: justify;"><span style="font-family: Verdana; font-size: 16px;">&nbsp;&nbsp; <span style="line-height: 115%; color: #595959;">Вспомним слова из этого текста:<br>
«сосредоточенность», «нацеленность на выполнение задачи». И одинаково это может относиться к проблемам производственным, бытовым, или связанным со здоровьем. Довести до больничной койки могут одинаково и переживания по поводу незавершённого ремонта, и обида на кого-то из близких, и страхи после первых — тогда ещё не хронических — симптомов, и непрестанные, изматывающие думы «о вспашке зяби», то есть «о делах». Усилия, направленные на выполнение главной для личности задачи: «решить проблему» до поры вполне оправданы. Именно ДО ПОРЫ. И вот тут — внимание — вопрос: как расчитать эти усилия, как их распределить, чтобы хватило — и времени и энергии для решения ИМЕННО ЭТОЙ ЗАДАЧИ («завершить ремонт», «добиться справедливости в отношениях», «поправить здоровье при первых сигналах», «сдать отчёт, объект, выполнить план» и т.&nbsp;п.). Есть немалое количество задач, которые невозможно выполнить сразу, за один день. И тогда необходимо вспомнить знакомое с детства «<b>утро вечера мудренее</b>» — как ключевую формулу</span> <span style="line-height: 115%; color: #595959;">«стратегии остановок в пути» для восстановления сил, пополнения<br>
энергии. Именно в этом <b>может помочь специалист психотерапевт</b>. Не всегда и не обязательно бывает «погружаться в проблему», «анализировать причины», порой бывает вполне достаточно <b>найти дополнительные ресурсы</b> или пересмотреть своё отношение к тому, что считалось трудным и неразрешимым. Есть ведь шанс того, что «ларчик, оказывается, просто открывается!..».</span></span></p>

            `
            }
        }
    }
}

</script>

<style lang="scss" scoped>
.container {
    text-align: left;
    font-family: Arial, sans-serif;
    font-size: 13px;
}

strong {
    color: rgb(0, 0, 0);
    font-weight: 700;
    padding: 0;
}

p {
    padding: 1em 0;
    color: #666;
    line-height: 150%;
}

.bold {
    font-weight: bold;
}

.left-1em {
    margin-left: 1em;
}

h3 {
    font-size: 18px;
    margin: 0;
    padding: 0;
    font-weight: normal;
    color: #000;
}

h3:after {
    content: "";
    display: block;
    bottom: 0;
    width: 50px;
    height: 2px;
    background: #00b6cc;
    margin-top: 10px
}

.inv-divider {
    height: 32px;
    display: block;
    width: 100%;
}

.divider {
    height: 1px;
    border-top: 1px solid #ebebeb;
    display: block;
    position: relative;
    top: 1px;
    width: 100%;
    margin: 20px 0;
}

.flex {
    display: flex;
}

.flex.center {
    align-items: center;
}

.box {
    display: inline-block;
    text-align: center;
    width: 225px;
    margin-left: 30px;
}

.box:first-child {
    margin: 0;
}

.link {
    color: #006688;
    border-bottom: 1px dotted #006688;
    text-decoration: none;
    display: block;
    width: fit-content;
    height: fit-content;
}

.left-30px {
    margin-left: 30px;
}

hr {
    display: block;
    unicode-bidi: isolate;
    margin-block-start: 0.5em;
    margin-block-end: 0.5em;
    margin-inline-start: auto;
    margin-inline-end: auto;
    overflow: hidden;
    border-style: inset;
    border-width: 1px;
    color: #666;
    line-height: 1;
}

</style>

<style lang="scss" scoped>
.article-detail {
    display: flex;
    margin-top: 30px;

    .comment_box {
        width: 100px;
        display: flex;
        align-items: center;
        margin-bottom: 25px;
        flex-direction: column;

        .date {
            width: 100%;
            position: relative;
        }

        .date .value {
            background-color: #006688;
            color: #fff;
            padding: 10px 13px;
            font-size: 12px;
            width: 100%;

            @media screen and (max-width: 768px) {
                padding: 10px 10px;
            }
        }

        .comments_number {
            width: 100%;
            margin-top: 4px;
            background-color: #00b6cc;
            padding: 10px 12px;
            color: #fff;
            font-size: 12px;
        }

        .arrow_date {
            content: '';
            top: 0;
            right: -4px;
            display: inline;
            border-color: #006688 transparent;
            visibility: visible;
            position: absolute;
            border-style: solid;
            border-width: 5px 5px 0 0;
        }
    }


    &__content {
        margin-left: 20px;
        border-bottom: 1px solid #E0E0E0;
    }

    &__title {
        text-align: left;

    }

    @media screen and (max-width: 450px) {

        &__title {
            h2 {
                font-size: 18px;
            }

        }
    }

    &__image {
        width: 60%;

        img {
            width: 100%;
            margin: 5px 20px 20px 0;
        }
    }

    &__desc {

        p {
            text-align: left;
            font-size: 14px;
        }

        .more-detail {
            font-size: 14px;
            margin: 15px 0;
        }

        .routes {
            margin: 15px 0;
        }
    }
}

.comment-wrapper {
    margin-left: 120px;
    margin-top: 30px;
    padding: 10px;

    @media screen and (max-width: 570px) {
        margin-left: 0;
    }
}
</style>

<style>
.article-detail__content {
    width: 100% !important;
}
</style>
